import styled from "styled-components";

import { TicketsCategoryPlaceholderStyledProps as Props } from "./TicketsCategoryPlaceholder.types";

const TicketsCategoryPlaceholderStyled = styled.div<Props>`
  flex: 1;

  .TicketsCategoryPlaceholder {
    &__ticket {
      margin-top: 0.8rem;
      position: relative;
      flex-direction: row;
      height: 8.8rem;
      justify-content: space-between;
      align-items: center;
      padding-top: 2rem;
      padding-left: 4rem;
      border-radius: 1rem;
      background-color: var(--palette-gray-s0-l30-a40);
      overflow: hidden;
      margin-bottom: 1.6rem;
    }

    &__dot-container {
      position: absolute;
      justify-content: center;
      top: 3.2rem;
      bottom: 0;
    }

    &__dot {
      width: 3.2rem;
      height: 3.2rem;
      background-color: var(--palette-dark-blue-s13-l11);
      border-radius: 12rem;
    }

    &__left-dot-container {
      left: -1.6rem;
    }

    &__right-dot-container {
      right: -1.6rem;
    }

    &__header {
      width: 12.4rem;
      height: 3.6rem;
      border-radius: 0.8rem;
      margin-bottom: 1.6rem;
      margin-top: 2.4rem;
    }

    &__title {
      width: 8.8rem;
      height: 2.4rem;
      border-radius: 0.8rem;
    }

    &__message {
      width: 10.4rem;
      height: 2.4rem;
      border-radius: 0.8rem;
    }

    &__description {
      width: 5.6rem;
      height: 1.6rem;
      margin-top: 0.8rem;
      border-radius: 0.8rem;
    }
  }
`;

export default TicketsCategoryPlaceholderStyled;
